import Link from 'next/link';
import { Common, color } from '@stockbit/ui';

import { subscribeMessage, subscribeButton } from './constants';
import { WidgetAction, LinkSubscribeWrapper, ButtonSubscribe } from './styled';

const { Iconmoon } = Common;

interface NotProProps {
  width?: string;
  height?: string;
  className?: string;
}

function NotPro({ width, height, className }: NotProProps) {
  return (
    <WidgetAction className={className} style={{ height: height || 'auto' }}>
      <div>
        <span>{subscribeMessage}</span>
      </div>

      <LinkSubscribeWrapper>
        <Link href="/shop">
          <a>
            <ButtonSubscribe type="primary" width={width}>
              <Iconmoon
                className="icon-setting_subscribe"
                color={color.light}
              />
              {subscribeButton}
            </ButtonSubscribe>
          </a>
        </Link>
      </LinkSubscribeWrapper>
    </WidgetAction>
  );
}

export default NotPro;
